import { Component, ReactNode } from 'react'
import { ModalNode, ModalNodeProps } from '../../../components/modal.component'
import { AccountInfoDto, BlockOffEmployee, BlockTimeType } from '../../../../definition'
import moment from 'moment'
import { Button } from 'antd'
import { asyncDeleteBlockOff } from '../../../../services/booking.service'
import { appEventEmitter, processLoading } from '../../../../initialization'
import { toast } from 'react-toastify'
import { APP_EVENTS } from '../../../../constants'
import { RemoveRecurringBlockModal } from './remove-recurring-block-mode'

export class BlockOffItemModal extends Component<
  ModalNodeProps,
  { block: BlockOffEmployee; technicians: AccountInfoDto[]; date: string }
> {
  constructor(props: any) {
    super(props)
    const data = this.props.input
    this.state = {
      block: data.block,
      technicians: data.technicians,
      date: data.date
    }
  }

  async removeBlock() {
    if (this.state.block.type === BlockTimeType.Recurring) {
      appEventEmitter.emit<ModalNode>(APP_EVENTS.app_modal, {
        input: {
          date: this.state.date,
          blockId: this.state.block.id,
          refreshSchedule: this.props.input.refreshSchedule
        },
        status: true,
        node: RemoveRecurringBlockModal,
        title: 'Delete Recurring Time block',
        onClose: () => {},
        onDone: () => {}
      })
      this.props.onClose?.()
    } else {
      this.props.input.refreshSchedule()
      try {
        await asyncDeleteBlockOff(this.state.block.id)
        this.props.input.refreshSchedule()
        this.props.onClose?.()
        toast.success('Removed')
      } catch (error: any) {
        const errorMessage = error.response?.data?.error?.message || error.message
        toast.error(`${errorMessage}`)
      }
    }
  }

  render(): ReactNode {
    return (
      <div className='blog-off-modal' style={{ width: 500 }}>
        {this.state.block.date && (
          <div className='blog-off-info'>
            <label>Date</label>
            <div>: {moment(this.state.block.date).format('DD/MM/YYYY')}</div>
          </div>
        )}
        <div className='blog-off-info'>
          <label>Employees</label>
          <div>: {this.state.technicians.find((tech) => this.state.block.accountId === tech.id)?.profile?.name}</div>
        </div>
        <div className='blog-off-info'>
          <label>Once/Recurring</label>
          <div>: {this.state.block.type === BlockTimeType.Recurring ? 'Recurring' : 'Does not repeat'}</div>
        </div>
        {this.state.block.dayOfWeek && (
          <div className='blog-off-info'>
            <label>Day of Week</label>
            <div>: {this.state.block.dayOfWeek}</div>
          </div>
        )}
        <div className='blog-off-info'>
          <label>Partial</label>
          <div>: {this.state.block.begin ? 'Yes' : 'No'}</div>
        </div>
        {this.state.block.begin && (
          <div className='blog-off-info'>
            <label>Time Block Start Time</label>
            <div>: {moment(this.state.block.begin, 'hh:mmA').format('HH:mm')}</div>
          </div>
        )}
        {this.state.block.end && (
          <div className='blog-off-info'>
            <label>Time Block End Time</label>
            <div>: {moment(this.state.block.end, 'hh:mmA').format('HH:mm')}</div>
          </div>
        )}
        <div className='blog-off-info'>
          <label>Reason</label>
          <div>: {this.state.block.reason || '__'}</div>
        </div>
        <div className='action'>
          <Button onClick={() => this.props.onClose?.()}>Cancel</Button>
          <Button type='primary' onClick={() => this.removeBlock()}>
            Remove
          </Button>
        </div>
      </div>
    )
  }
}
